module.exports = __webpack_public_path__ + "img/1-1.a66bff02.png";